import Ten99Saga from 'Agent/1099s/sagas/Ten99Saga';
import {watchFetchAccountDetails, fetchAccountImages} from 'Agent/Accounts/ducks/accountDetail';
import accountSaga from 'Agent/Accounts/sagas/accountSaga';
import enrollmentApplicationSaga from 'Agent/Accounts/sagas/enrollmentApplicationSaga';
import a360EnrollmentApplicationSaga from 'Agent/Accounts/sagas/a360EnrollmentApplicationSaga';
import discrepancySummarySaga from 'Agent/Accounts/sagas/discrepancySummarySaga';
import agentsSaga from 'Agent/AgentInformation/sagas';
import agentDocumentationSaga from 'Agent/AgentDocumentation/sagas';
import {watchFetchClaims} from 'Agent/Claims/ducks/claim';
import claimSaga from 'Agent/Claims/sagas';
import commissionsSaga from 'Agent/Commissions/sagas';
import policyApplicationsSaga from 'Agent/Policies/sagas/policyApplicationsSaga';
import policyCorrespondenceSaga from 'Agent/Policies/sagas/policyCorrespondenceSaga';
import policySaga from 'Agent/Policies/sagas/policySaga';
import policyServiceRequestSaga from 'Agent/Policies/sagas/policyServiceRequestSaga';
import NewsSaga from 'AgentNewsAdministration/sagas';
import {deleteAlertSaga, getAlertSaga, getAlertsSaga, getUserAlertsSaga, saveAlertSaga} from 'Core/ducks/alerts';
import coreSaga from 'Core/sagas';
import legalAcceptanceSaga from 'Core/sagas/legalAcceptanceSaga';
import legalDocumentSaga from 'Core/sagas/legalDocumentSaga';
import {all} from 'redux-saga/effects';
import userSaga from 'Users/sagas';
import BulletinsSaga from 'Agent/AgentForms/Bulletins/sagas/Bulletin';
import InteractiveFormSaga from 'Agent/AgentForms/Interactive/sagas/Interactive';
import MarketingFormSaga from 'Agent/AgentForms/Marketing/sagas/Marketing';
import footerSaga from 'Core/sagas/footerSaga';
import featureFlagSaga from 'Core/sagas/featureFlagSaga';
import documentUploadSaga from 'Agent/DocumentUploadHistory/sagas/documentUploadSaga';
import quarantineSaga from 'Core/sagas/quarantineSaga';
import quotingToolSaga from 'Quoting/saga';
import taxYearsSaga from 'Core/sagas/taxYearsSaga';

export default function* rootSaga() {
  while (true) {
    try {
      yield all([
        NewsSaga(),
        Ten99Saga(),
        BulletinsSaga(),
        InteractiveFormSaga(),
        MarketingFormSaga(),
        accountSaga(),
        enrollmentApplicationSaga(),
        a360EnrollmentApplicationSaga(),
        agentDocumentationSaga(),
        agentsSaga(),
        claimSaga(),
        commissionsSaga(),
        coreSaga(),
        deleteAlertSaga(),
        discrepancySummarySaga(),
        getAlertSaga(),
        getAlertsSaga(),
        getUserAlertsSaga(),
        legalAcceptanceSaga(),
        legalDocumentSaga(),
        policyApplicationsSaga(),
        policyCorrespondenceSaga(),
        policySaga(),
        policyServiceRequestSaga(),
        saveAlertSaga(),
        userSaga(),
        watchFetchAccountDetails(),
        fetchAccountImages(),
        watchFetchClaims(),
        footerSaga(),
        featureFlagSaga(),
        documentUploadSaga(),
        quarantineSaga(),
        quotingToolSaga(),
        taxYearsSaga()
      ]);
    } catch (e) {
      console.error('saga aborted due to:', e);
      console.log('restarting the saga...');
    }
  }
}
